var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C10 3.10457 9.10458 4 8 4C6.89542 4 6 3.10457 6 2C6 0.895432 6.89542 0 8 0C9.10458 0 10 0.895432 10 2Z",
    fill: "#97B912"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.5C5 4.32843 4.32843 5 3.5 5C2.67157 5 2 4.32843 2 3.5C2 2.67157 2.67157 2 3.5 2C4.32843 2 5 2.67157 5 3.5Z",
    fill: "#97B912"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5C13.3284 5 14 4.32843 14 3.5C14 2.67157 13.3284 2 12.5 2C11.6716 2 11 2.67157 11 3.5C11 4.32843 11.6716 5 12.5 5Z",
    fill: "#97B912"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 9.10457 15.1046 10 14 10C12.8954 10 12 9.10457 12 8C12 6.89543 12.8954 6 14 6C15.1046 6 16 6.89543 16 8Z",
    fill: "#97B912"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14C13.3284 14 14 13.3284 14 12.5C14 11.6716 13.3284 11 12.5 11C11.6716 11 11 11.6716 11 12.5C11 13.3284 11.6716 14 12.5 14Z",
    fill: "#97B912"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C10 15.1046 9.10458 16 8 16C6.89542 16 6 15.1046 6 14C6 12.8954 6.89542 12 8 12C9.10458 12 10 12.8954 10 14Z",
    fill: "#97B912"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14C4.32843 14 5 13.3284 5 12.5C5 11.6716 4.32843 11 3.5 11C2.67157 11 2 11.6716 2 12.5C2 13.3284 2.67157 14 3.5 14Z",
    fill: "#97B912"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 9.10457 3.10458 10 2 10C0.895416 10 0 9.10457 0 8C0 6.89543 0.895416 6 2 6C3.10458 6 4 6.89543 4 8Z",
    fill: "#97B912"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C9.10458 10 10 9.10457 10 8C10 6.89543 9.10458 6 8 6C6.89542 6 6 6.89543 6 8C6 9.10457 6.89542 10 8 10Z",
    fill: "#97B912"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganization);
export default __webpack_public_path__ + "static/media/icon-Organization.a3a4de96380f901442e393a2d4478497.svg";
export { ForwardRef as ReactComponent };